import React from 'react';
import { DatePicker, Form, Input, Radio, Select } from 'antd';
import { TASK_PRIORITY_OPTIONS } from '../constants';
import type { TaskPriority } from '../types';

interface ScheduleNextFollowupFieldsProps {
  showPriority?: boolean;
}

const ScheduleNextFollowupFields: React.FC<ScheduleNextFollowupFieldsProps> = ({
  showPriority = false,
}) => {
  const scheduleNext = Form.useWatch<boolean>('scheduleNext');

  return (
    <>
      <Form.Item name="scheduleNext" label="Schedule next follow-up?">
        <Radio.Group>
          <Radio value={false}>No</Radio>
          <Radio value={true}>Yes</Radio>
        </Radio.Group>
      </Form.Item>
      {scheduleNext && (
        <>
          {showPriority && (
            <Form.Item
              name="nextPriority"
              label="Priority"
              rules={[{ required: true, message: 'Priority is required' }]}
            >
              <Select<TaskPriority> placeholder="Select priority" options={TASK_PRIORITY_OPTIONS} />
            </Form.Item>
          )}
          <Form.Item
            name="nextDueDate"
            label="Next due date"
            rules={[{ required: true, message: 'Next due date is required' }]}
          >
            <DatePicker style={{ width: '100%' }} getPopupContainer={(trigger) => trigger.parentElement!} />
          </Form.Item>
          <Form.Item
            name="nextTitle"
            label="Next task title"
            rules={[{ required: true, message: 'Title is required' }]}
          >
            <Input placeholder="e.g. Call back for demo" maxLength={256} />
          </Form.Item>
          <Form.Item name="nextDescription" label="Description (optional)">
            <Input.TextArea rows={2} maxLength={4000} />
          </Form.Item>
        </>
      )}
    </>
  );
};

export default ScheduleNextFollowupFields;
